import { render, staticRenderFns } from "./MatchFollowSection.vue?vue&type=template&id=07c6f701&scoped=true"
import script from "./MatchFollowSection.vue?vue&type=script&lang=js"
export * from "./MatchFollowSection.vue?vue&type=script&lang=js"
import style0 from "./MatchFollowSection.vue?vue&type=style&index=0&id=07c6f701&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6f701",
  null
  
)

export default component.exports